export default {
  current_password: '',
  new_password: '',
  confirm_new_password: '',
};
